export const NotificationEvents = {
  USER_ACCOUNT_APPROVED: 'USER_ACCOUNT_APPROVED',
  USER_REGISTERED: 'USER_REGISTERED',
  USER_FORGOT_PASSWORD: 'USER_FORGOT_PASSWORD',
  USER_PASSWORD_CHANGED: 'USER_PASSWORD_CHANGED',
  USER_ASSIGNED_NEW_LOCATION: 'USER_ASSIGNED_NEW_LOCATION',

  ADMIN_NEW_USER_REGISTERED: 'ADMIN_NEW_USER_REGISTERED',
  ADMIN_NEW_ORDER_PLACED: 'ADMIN_NEW_ORDER_PLACED',
  ADMIN_NOTIFY_CUSTOMER_CARE: 'ADMIN_NOTIFY_CUSTOMER_CARE',
  ADMIN_NEW_CASE_CREATED: 'ADMIN_NEW_CASE_CREATED',
  ADMIN_CONTACT_CCR_FORM: 'ADMIN_CONTACT_CCR_FORM',
  ADMIN_MACHINE_SELL_NOTIFY: 'ADMIN_MACHINE_SELL_NOTIFY',

  USER_REQUESTLIST_PURCHASABLE: 'USER_REQUESTLIST_PURCHASABLE',
  USER_NEW_DOCUMENT_ADDED: 'USER_NEW_DOCUMENT_ADDED',
  USER_ORDER_SUCCESS: 'USER_ORDER_SUCCESS',
  USER_PART_ORDER_REMINDER: 'USER_PART_ORDER_REMINDER',
};

export const NotificationEventLabels = {
  USER_ACCOUNT_APPROVED: 'Account approved',
  USER_REGISTERED: 'Registration confirmation',
  USER_FORGOT_PASSWORD: 'Forgot password',
  USER_PASSWORD_CHANGED: 'Password changed',
  USER_ASSIGNED_NEW_LOCATION: 'Assigned new customer location',

  ADMIN_NEW_USER_REGISTERED: 'New user registered',
  ADMIN_NEW_ORDER_PLACED: 'New order placed',
  ADMIN_NOTIFY_CUSTOMER_CARE: 'Notify Customer Care',
  ADMIN_NEW_CASE_CREATED: 'New case created',
  ADMIN_CONTACT_CCR_FORM: 'Contact CCR form submitted',
  ADMIN_MACHINE_SELL_NOTIFY: 'Machine sold notification',

  USER_REQUESTLIST_PURCHASABLE: 'Request list parts purchasable',
  USER_NEW_DOCUMENT_ADDED: 'New document added',
  USER_ORDER_SUCCESS: 'Order placed successfully',
  USER_PART_ORDER_REMINDER: 'Part order reminder',
};
